var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.SETTING_ORGANIZATION_ROUTE_LIST },
      }),
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("GroupSettings.information")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName:
                            "v-permission:SettingUserOrganizationGroup_Edit",
                          arg: "SettingUserOrganizationGroup_Edit",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.isEdit = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("editText")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancelText")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "app-container",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "200px" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("GroupSettings.name"), prop: "groupName" },
            },
            [
              _vm.isEdit
                ? _c("BjInput", {
                    attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, clearable: "" },
                    model: {
                      value: _vm.form.groupName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "groupName", $$v)
                      },
                      expression: "form.groupName",
                    },
                  })
                : _c("span", [_vm._v(_vm._s(_vm.form.groupName))]),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("GroupSettings.abbreviated"),
                prop: "groupShortName",
              },
            },
            [
              _vm.isEdit
                ? _c("BjInput", {
                    attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, clearable: "" },
                    model: {
                      value: _vm.form.groupShortName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "groupShortName", $$v)
                      },
                      expression: "form.groupShortName",
                    },
                  })
                : _c("span", [_vm._v(_vm._s(_vm.form.groupShortName))]),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "LOGO", prop: "logo" } },
            [
              _c(
                "BjUpload",
                {
                  ref: "upload",
                  staticClass: "avatar-uploader",
                  attrs: {
                    "auto-upload": "",
                    disabled: !_vm.isEdit,
                    "accept-list": ["image/jpeg", "image/png"],
                    "limit-size": 500,
                  },
                  on: { afterUpload: _vm.afterUpload_logo },
                },
                [
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _vm.form.logo
                        ? _c("BjKeyImage", {
                            staticClass: "avatar",
                            attrs: { url: _vm.form.logo },
                          })
                        : [
                            _vm.isEdit
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon",
                                })
                              : _c("i", {
                                  staticClass:
                                    "el-icon-picture-outline avatar-uploader-icon",
                                }),
                          ],
                    ],
                    2
                  ),
                  _c("template", { slot: "tip" }, [
                    _vm._v(" " + _vm._s(_vm.$t("GroupSettings.ps1")) + " "),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Favicon" } },
            [
              _c(
                "BjUpload",
                {
                  ref: "upload",
                  staticClass: "avatar-uploader",
                  attrs: {
                    "auto-upload": "",
                    disabled: !_vm.isEdit,
                    "accept-list": ["image/x-icon"],
                    "limit-size": 200,
                  },
                  on: { afterUpload: _vm.afterUpload_ico },
                },
                [
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _vm.form.favicon
                        ? _c("BjKeyImage", {
                            staticClass: "avatar",
                            attrs: { url: _vm.form.favicon },
                          })
                        : [
                            _vm.isEdit
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon",
                                })
                              : _c("i", {
                                  staticClass:
                                    "el-icon-picture-outline avatar-uploader-icon",
                                }),
                          ],
                    ],
                    2
                  ),
                  _c("template", { slot: "tip" }, [
                    _vm._v(" " + _vm._s(_vm.$t("GroupSettings.ps2")) + " "),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }